var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_dollar-square",
    "data-name": "vuesax/bold/dollar-square",
    transform: "translate(-172 -572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dollar-square",
    transform: "translate(172 572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.05,0V4.767L1.367,4.183C.517,3.883,0,3.6,0,2.15A2.069,2.069,0,0,1,1.967,0Z",
    transform: "translate(15.7 13.467)",
    fill: "#1a3680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.05,2.617a2.069,2.069,0,0,1-1.967,2.15H0V0L1.683.583C2.533.883,3.05,1.167,3.05,2.617Z",
    transform: "translate(21.25 21.767)",
    fill: "#1a3680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M23.65,0H9.683C3.617,0,0,3.617,0,9.683V23.65c0,6.067,3.617,9.683,9.683,9.683H23.65c6.067,0,9.683-3.617,9.683-9.683V9.683C33.333,3.617,29.717,0,23.65,0ZM20.433,16.667a4.139,4.139,0,0,1,3.033,4.383A4.562,4.562,0,0,1,19,25.7H17.917v.967a1.25,1.25,0,0,1-2.5,0V25.7h-.6a5.06,5.06,0,0,1-4.95-5.15,1.25,1.25,0,1,1,2.5,0,2.556,2.556,0,0,0,2.45,2.65h.6V17.55L12.9,16.667a4.139,4.139,0,0,1-3.033-4.383,4.562,4.562,0,0,1,4.467-4.65h1.083V6.667a1.25,1.25,0,1,1,2.5,0v.967h.6a5.06,5.06,0,0,1,4.95,5.15,1.25,1.25,0,0,1-2.5,0,2.556,2.556,0,0,0-2.45-2.65h-.6v5.65Z",
    transform: "translate(3.333 3.333)",
    fill: "#1a3680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H40V40H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollerIcon);
export default __webpack_public_path__ + "static/media/doller_icon.c47cfebe054578fe1b0ae0d3d80327e2.svg";
export { ForwardRef as ReactComponent };